import { render, staticRenderFns } from "./company-intention.vue?vue&type=template&id=5f89010c&scoped=true"
import script from "./company-intention.vue?vue&type=script&lang=ts"
export * from "./company-intention.vue?vue&type=script&lang=ts"
import style0 from "./company-intention.vue?vue&type=style&index=0&id=5f89010c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f89010c",
  null
  
)

export default component.exports